import React from "react";
import { FiFileText } from "react-icons/fi";
import { WordTitle } from "../../../../utils/commonFunction";
import Table from "../../../../components/table/table";
import { ReactSelectInput } from "../../../../components/select/react-select";
import AIIcon from "../../../../assets/icons/AIIcon.png";
import { NotesState, NotesActions } from "../types";

interface NotesTableProps {
  state: NotesState;
  actions: NotesActions;
}

const NotesTable: React.FC<NotesTableProps> = ({ state, actions }) => {
  const {
    loader,
    notesData,
    senderName,
    noteType,
    selectedDos,
    selectedRows,
    page,
    totalPage,
  } = state;

  const {
    handleSenderNameChange,
    handleNoteTypeChange,
    handleDosChange,
    handleDosClear,
    setSelectedRows,
    handleSort,
    handleNextPage,
    redirectNotesPage,
    handleShowAISummarizeModal,
    handleTodoPrompt,
  } = actions;

  return (
    <div className="mt-2 grid grid-cols-12 gap-1">
      <div className="col-span-4 flex items-center">
        <h6 className="text-[#1C0F03] font-[600] text-[20px]">Notes</h6>
      </div>

      <div className="col-span-8 flex gap-[16px] items-center justify-end mb-[4px] mt-2">
        <ReactSelectInput
          name="senderName"
          onChange={handleSenderNameChange}
          options={senderName}
          placeholder="Select Sender Name"
          className="w-[250px]"
          isSearchable={true}
          isClearable={true}
          isDisabled={false}
        />
        <ReactSelectInput
          name="noteType"
          onChange={handleNoteTypeChange}
          options={noteType}
          placeholder="Select Note Type"
          className="w-[250px]"
          isSearchable={true}
          isClearable={true}
          isDisabled={false}
        />

        <input
          type="text"
          placeholder="Select DOS"
          onFocus={(e) => (e.target.type = "date")}
          onBlur={(e) => {
            if (!e.target.value) e.target.type = "text";
          }}
          value={selectedDos ?? ""}
          onChange={(e) => handleDosChange(e.target.value)}
          className="w-[250px] h-[40px] border border-gray-300 rounded-md px-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        {selectedDos && selectedDos !== "" ? (
          <p className="text-[red] cursor-pointer" onClick={handleDosClear}>
            Clear
          </p>
        ) : null}
      </div>

      <div className="col-span-12">
        <Table
          loading={loader}
          data={notesData}
          tableScroll={"100%"}
          sort={true}
          Clickable={true}
          showCheckbox={true}
          selectedRows={selectedRows}
          MultiOperationButtonIconComponent={
            <img src={AIIcon} alt="AI" className="w-5 h-5" />
          }
          showModalSelectedAbove={0}
          MultiDeletedFucn={() => handleShowAISummarizeModal(false)}
          MultiOperationButtonIconClass="bg-white hover:bg-teal-50 disabled:bg-white disabled:opacity-50 border-[#17be62] hover:border-[#14a085]"
          setSelectedRows={setSelectedRows}
          MultiOperationButton={"Summarize"}
          MultiOperationButton2={"To Do"}
          MultiOperationButton2Func={handleTodoPrompt}
          MultiOperationButton2IconComponent={
            <img src={AIIcon} alt="AI" className="w-5 h-5" />
          }
          MultiOperationButton2IconClass="bg-white hover:bg-teal-50 disabled:bg-white disabled:opacity-50 border-[#17be62] hover:border-[#14a085]"
          rowClick={redirectNotesPage}
          hasNextPage={page < totalPage}
          NextPageData={handleNextPage}
          columns={["Sender", "DOS", "Note Type", "Action"]}
          sortTitleKeys={{
            Sender: "sender_name",
            DOS: "encounter_date",
            "Note Type": "note_type",
          }}
          handleSortfunc={handleSort}
          scopedSlots={{
            Sender: ({ row }: any) => (
              <td title={row?.sender_name || ""}>
                <div className="max-w-[200px] truncate cursor-pointer">
                  {WordTitle(row?.sender_name || "")}
                </div>
              </td>
            ),
            DOS: ({ row }: any) => (
              <td title={row?.encounter_date || ""}>
                <div className="max-w-[150px] truncate cursor-pointer">
                  {row?.encounter_date || ""}
                </div>
              </td>
            ),
            "Note Type": ({ row }: any) => (
              <td title={row?.note_type || ""}>
                <div className="max-w-[150px] truncate cursor-pointer">
                  {WordTitle(row?.note_type || "")}
                </div>
              </td>
            ),
            Action: ({ row }: any) => {
              return (
                <td>
                  <div className="flex gap-[16px] items-center justify-center pr-[4px]">
                    <a
                      href={`/notes/${row.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="no-underline"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <FiFileText
                        fontWeight={900}
                        fontSize={22}
                        title="Notes Content"
                      />
                    </a>
                  </div>
                </td>
              );
            },
          }}
        />
      </div>
    </div>
  );
};

export default NotesTable;